import CircularProgress, {
    CircularProgressProps as MuiCircularProgressProps
} from '@mui/material/CircularProgress';
import * as React from 'react';

import { FlexBox } from '../box';
import { styled } from '../styled';
import { Typography } from '../typography';

const RootBox = styled(FlexBox)({
    display: 'inline-flex'
});

const ProgressWrapper = styled(FlexBox)({
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
});

export type CircularProgressProps = MuiCircularProgressProps;
export type CircularProgressWithLabelProps = Omit<
    MuiCircularProgressProps,
    'variant'
>;

export const CircularProgressWithLabel = (
    props: CircularProgressWithLabelProps
) => {
    const { value, ...muiProps } = props;

    const progressValue = Math.min(value ?? 0, 100);

    return (
        <RootBox position="relative">
            <CircularProgress
                variant="determinate"
                {...muiProps}
                value={progressValue}
            />
            <ProgressWrapper
                position="absolute"
                vAlign="center"
                hAlign="center"
            >
                <Typography
                    variant="detail"
                    component="div"
                    color="text.secondary"
                >
                    {`${Math.round(progressValue)}%`}
                </Typography>
            </ProgressWrapper>
        </RootBox>
    );
};

export { CircularProgress };
